import classNames from "classnames";
import ImageCell from "./ImageCell";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import GridCell, { GridCellCommonProps } from "./GridCell";
import { storiesBaseUrl } from "../../config/urls";
import { Story } from "../../types/Story";
import { useStoryById } from "../../hooks/CmsHooks";
import { Suspense } from "react";
import { Spinner } from "reactstrap";
import Color from "color";
import "./style.scss";

const StoryCellInner = ({
  id,
  className,
  cellSize = "1x1",
  story: _story,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { story: Story }) => {
  const story = useStoryById(_story._id);
  const bkgColor = Color(story.featured_image?.colors?.[0])
    .darken(0.4)
    .saturate(0.5);
  const textBkgColor = bkgColor.fade(0.3);

  return story ? (
    <ImageCell
      id={id}
      className={classNames("story-cell", className)}
      cellSize={cellSize}
      theme={theme}
      bkgColor={bkgColor.hex()}
      textBkgColor={textBkgColor.toString()}
      requiresFeature={requiresFeature}
      heading={story.title}
      text={story.description || ""}
      label="Bjelin stories"
      image={story.featured_image}
      url={storiesBaseUrl + "/" + story.path}
      {...unhandledProps}
    />
  ) : null;
};

const StoryCell = ({
  id,
  className,
  cellSize = "1x1",
  story: _story,
  theme = "black",
  requiresFeature,
  ...unhandledProps
}: GridCellCommonProps & { story: Story }) => {
  const features = useSiteFeatures();

  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <Suspense
      fallback={
        <GridCell
          id={id}
          className={classNames("story-cell", className)}
          cellSize={cellSize}
          theme={theme}
        >
          <Spinner />
        </GridCell>
      }
    >
      <StoryCellInner
        id={id}
        className={classNames("story-cell", className)}
        cellSize={cellSize}
        theme={theme}
        story={_story}
        requiresFeature={requiresFeature}
        {...unhandledProps}
      />
    </Suspense>
  ) : null;
};

export default StoryCell;
